// extracted by mini-css-extract-plugin
export default {"descrption":"Descrption_descrption__lFKIX","descrption__title":"Descrption_descrption__title__Jq4iI"};